import {
  Box,
  BoxProps,
  Flex,
  Heading,
  Icon,
  mdBumps,
  smBumps,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'

export interface ReferralReasonsProps extends BoxProps {
  quote: Quote
}

const tKey = TKey('components.referral-reasons')

export const ReferralReasons: FunctionComponent<ReferralReasonsProps> = ({
  quote,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const referralReasons = quote.referralReasons
  const referralDetails = referralReasons.map((it, index) => (
    <Flex key={index} justifyContent='flex-start'>
      <Icon icon='warning' size='small' mr={smBumps} />
      <Typo>{it.message}</Typo>
    </Flex>
  ))

  return referralDetails.length ? (
    <Box
      borderWidth={1}
      borderRadius={2}
      borderColor='surfaceCritical'
      bg='surfaceCriticalSubdued'
      p={mdBumps}
      {...props}
    >
      <Heading as='h3' variant='h3' typoSize='md' mb={smBumps}>
        {t(tKey('header'))}
      </Heading>
      <Flex flexDirection='column' alignItems='flex-start' gap={3} width={1}>
        {referralDetails}
      </Flex>
    </Box>
  ) : null
}
